/** Historical terminal process cards remain in durable transcripts, but are never live telemetry. */
export function isBackgroundProcessCardId(id: string): boolean {
  return id === 'bg-processes' || id.startsWith('bg-processes-');
}
